import React, { useEffect, useRef } from 'react';
import maplibregl from 'maplibre-gl';
import 'maplibre-gl/dist/maplibre-gl.css';
import { BASEMAPS } from 'components/Tiles/basemaps';

const ChatMapEmbed = ({ lat, lng, zoom = 6, markers = [], href, label }) => {
  const containerRef = useRef(null);
  const mapRef = useRef(null);
  const latitude = Number(lat);
  const longitude = Number(lng);
  const markerKey = JSON.stringify(markers || []);

  useEffect(() => {
    if (!containerRef.current || !Number.isFinite(latitude) || !Number.isFinite(longitude)) {
      return undefined;
    }
    const tileUrl = (BASEMAPS.imagery.url || '').replace('{s}', 'a').replace('{r}', '');
    const map = new maplibregl.Map({
      container: containerRef.current,
      style: {
        version: 8,
        sources: {
          basemap: { type: 'raster', tiles: [tileUrl], tileSize: 256 },
        },
        layers: [{ id: 'basemap', type: 'raster', source: 'basemap' }],
      },
      center: [longitude, latitude],
      zoom: Number(zoom) || 6,
      attributionControl: false,
      interactive: true,
    });
    map.addControl(new maplibregl.NavigationControl({ showCompass: false }), 'top-right');
    let points = [];
    try {
      points = JSON.parse(markerKey);
    } catch (_) {
      points = [];
    }
    if (!Array.isArray(points) || !points.length) {
      points = [{ lat: latitude, lng: longitude, label: label || 'Site' }];
    }
    points.slice(0, 40).forEach((marker) => {
      const mlng = Number(marker.lng ?? marker.longitude);
      const mlat = Number(marker.lat ?? marker.latitude);
      if (!Number.isFinite(mlng) || !Number.isFinite(mlat)) return;
      const node = document.createElement('div');
      node.className = 'chat-map-marker';
      node.title = marker.label || '';
      new maplibregl.Marker({ element: node }).setLngLat([mlng, mlat]).addTo(map);
    });
    mapRef.current = map;
    return () => {
      try { map.remove(); } catch (_) { /* ignore */ }
      mapRef.current = null;
    };
  }, [latitude, longitude, zoom, markerKey, label]);

  if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) return null;

  return (
    <div className="chat-map-embed">
      <div className="chat-map-embed-head">
        <strong>{label || 'Map'}</strong>
        {href ? <a href={href}>Open full map</a> : null}
      </div>
      <div ref={containerRef} className="chat-map-embed-canvas" />
    </div>
  );
};

export default ChatMapEmbed;
